import { NgClass } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { Link, TrackingData } from '@ecm/router';

import { SubItemViewModel } from '../../../../business/model/home/subItem.view-model';
import { TrackedPage } from '../../../../business/model/tracking/trackedPage.enum';
import { SubItemComponent } from '../sub-item.component';

@Component({
    selector: 'fixe-sub-item',
    templateUrl: 'fixe-sub-item.html',
    styleUrls: ['../sub-item.css'],
    standalone: true,
    imports: [NgClass, TranslateModule],
})
export class FixeSubItemComponent extends SubItemComponent implements OnInit {
    public linkConso?: Link;

    public ngOnInit(): void {
        super.ngOnInit();
        this.setLinkConso(this.fixeviewModel);
    }

    private setLinkConso(fixeConso: SubItemViewModel[]) {
        fixeConso.forEach((conso: SubItemViewModel) => {
            if (conso.link != null) {
                this.linkConso = conso.link;
            }
        });
    }

    public openSuiviConso(link: Link) {
        if (link != null) {
            this.linkService.openLink(
                link,
                Object.assign(new TrackingData(), {
                    tmsTracking: {
                        trackedPage: TrackedPage.dashboard,
                        trackingArea: 'test',
                        trackingName: 'care_hp_top_alerte',
                    },
                }),
            );
        }
    }
}
